/**
 * Created by fengc on 2020/04/02.
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import * as Helper from "../../utils/Helper";
import { Text } from "native-base";

class Syllable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const convertPinYin = this.props.check ? Syllable.isSyllable(this.props.data) : true;
        return <Text allowFontScaling={true} style={this.props.style}>{!this.props.data || this.props.data === " " ? " " : (convertPinYin ? Helper.convertToPinyin(this.props.data) : this.props.data)}</Text>;
    }
}

Syllable.propTypes = {
    style: PropTypes.array,
    data: PropTypes.string,
};

Syllable.defaultProps = {
    style: [],
    data: "",
};

Syllable.isSyllable = function(data) {
    // 暂时简单判断长度小于10的为音调
    return data && (data.length < 10);
}

export default Syllable;
